import { render } from "./SingleSelect.vue?vue&type=template&id=706d041e"
import script from "./SingleSelect.vue?vue&type=script&lang=js"
export * from "./SingleSelect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/robo1/Documents/Admin/admv5-php/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__